// extracted by mini-css-extract-plugin
export default {"title":"SimpleAboutUsInfoView_title__dC9qK"};